/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["πρωί", "μεσημ.", "απόγ.", "βράδυ"], u, ["το πρωί", "το μεσημέρι", "το απόγευμα", "το βράδυ"]], [["πρωί", "μεσημ.", "απόγ.", "βράδυ"], u, ["πρωί", "μεσημέρι", "απόγευμα", "βράδυ"]], [["04:00", "12:00"], ["12:00", "17:00"], ["17:00", "20:00"], ["20:00", "04:00"]]];
